import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums'
import LoadingState from '../components/LoadingState'

const ConfirmRoleChanges = lazy(() => import('../pages/pages/ConfirmRoleChanges'))

export default [
  {
    path: '/confirm-role/:inviteToken',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.USER, UserRole.GUEST]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <ConfirmRoleChanges />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
